import { render, staticRenderFns } from "./themedTitle.vue?vue&type=template&id=b6e1ef5a&scoped=true&"
import script from "./themedTitle.vue?vue&type=script&lang=js&"
export * from "./themedTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e1ef5a",
  null
  
)

export default component.exports